export const pages = {
  auth: {
    login: {
      title: 'Giriş'
    },
    confirmation: {
      title: 'Onay Gönderi',
      description:
        'Size __var_0__ ile kod içeren bir mektup gönderdik. Gönderme bir dakikaya kadar sürebilir'
    },
    verifyEmail: {
      title: 'Şifre Değişikliği'
    },
    reset: {
      title: 'Şifre Değişikliği'
    },
    otp: {
      title: 'Onay Gönderi',
      description:
        'Size __var_0__ ile kod içeren bir mektup gönderdik. Gönderme bir dakikaya kadar sürebilir'
    },
    register: {
      title: 'Kayıt {role}'
    },
    invite: {
      title: "Live Bright Connect'e hoş geldiniz",
      description: 'Profil sürümünüzü seçin'
    }
  },
  notification: {
    title: 'Bildirimler',
    notFound: 'Henüz bildiriminiz yok.',
    description:
      'Profilinizde “Sanatçılar” bölümündeki sanatçılardan yeni uygulamaları görüntüleyebilirsiniz.'
  },
  loyalty: {
    inputLabel: 'Bağlantınız:',
    registered: 'Kayıtlı',
    followed_link: 'Bağlantıdan geçti',
    inputDescription:
      'Sanatçıyı davet etmek için kayıt için bir bağlantı gönderin.',
    artist: {
      title: 'Siteye Davet',
      description:
        'Bağlantınızın kaydını tamamlayan sanatçı davet edilen olarak kabul edilir.'
    },
    club: {
      title: 'Sadakat programı',
      note: 'Bağlantınızın kaydını tamamlayan sanatçı davet edilen olarak kabul edilir.',
      description: 'Komisyon olmadan sanatçıları alın!',
      text: '👯‍♀️ Bir oyuncu kadrosun var mıydı ve sanatçı uymadı mı? Birisi sözleşmeyi tamamlıyor mu? Ona kişisel bağlantınızı gönderin.',
      content:
        'Sanatçı bağlantınız tarafından kaydedildiğinde sizi sayar. 📌 Her 5 sanatçı için 1 takvim ayı için komisyon olmadan 1 sözleşme alırsınız. Sanatçı başka bir kulüp seçse bile, yine de tezgahınızda dikkate alınacaktır.‼ Uğu programa katılmak için kulübünüz profili doldurmalı ve aramada görünür olmalı, platformu paylaşmalı ve şimdi faydalar elde etmelidir.'
    }
  },
  language: {
    title: 'Diller',
    description: 'Platformun dilini seçin',
    options: {
      ru: 'Rusça',
      en: 'İngilizce',
      uk: 'Ukraynaca',
      it: 'İtalyanca',
      de: 'Almanca',
      tr: 'Türkçe',
      es: 'İspanyolca'
    }
  },
  profilePage: {
    techSupport: 'Bakım hizmeti',
    privacy: 'Koşullar ve gizlilik',
    artist: {
      work: 'Kulüpte çalışmak',
      infoEditSection: 'Düzenleme',
      infoAppSection: 'Başvuru',
      personalInfo: 'Kişisel bilgiler',
      portfolio: 'Portföy',
      invitationAndRequests: 'Uygulamalar ve Davetiyeler',
      hideProfile: 'Hesabı gizle',
      loyaltyLink: 'Bir Arkadaşı Davet Et'
    },
    club: {
      clubInfoSection: 'Kulüp bilgileri',
      artistsSection: 'Sanatçılar',
      artistHiring: 'Bir dizi sanatçı',
      loyaltyProgram: 'Sadakat programı',
      editingSection: 'Düzenleme',
      clubInfo: 'Kişisel bilgiler',
      conditions: 'Koşullar',
      approvedArtists: 'Onaylanmış sanatçılar',
      requestsAndInvitations: 'Uygulamalar ve Davetiyeler',
      applicationSection: 'Başvuru'
    }
  },
  portfolioPage: {
    title: 'Portföy',
    warnNotPublished:
      'Özgeçmiş yayınlanmadı. Bir özgeçmiş yayınlamak için portföyü doldurun.',
    warnfillPortfolio: 'Portföyü doldurun',
    warnf: 'Portföyü doldurun',
    warnFillSection: 'Davetin şansını artırmak için bu bölümü doldurun.'
  },
  profileInfo: {
    club: {
      title: 'Hakkında'
    },
    artist: {
      title: 'Hakkında'
    }
  },
  clubTerms: {
    title: 'Koşullar',
    description:
      'Tüm adımları tamamen doldurmaya çalışın. Reklamın sanatçılar için çekiciliği buna bağlıdır. Zorluklar ortaya çıkarsa yardım için dönün.',
    progressSteps: {
      schedule: 'Kulüp çalışma programı',
      contractTerms:
        'Minimum sözleşme, sanatçıların programı, biletler, havaalanından transfer',
      payments:
        'Ödemeler: bahis, garanti, faul, poples, go-go, depozito, gösteri, çay, tüketme, çılgın menü',
      workConditions:
        'Tüketme türü. Koreograf. Fotoğraf çekimleri. Pilonlar. Miktar',
      housing: 'Konut hakkında bilgi. Fotoğraf.',
      penalties: 'Ceza örgüsü',
      photo: 'Kulübün fotoğrafı',
      video: 'Kulüp videosu'
    }
  },
  clubEmployers: {
    title: 'Onaylanmış sanatçılar',
    tabs: {
      pending: 'Beklentiyle',
      onContract: 'Sözleşmede'
    }
  },
  requestAndInvitation: {
    title: 'Uygulamalar ve Davetiyeler'
  },
  onboarding: {
    club: {
      schedule: {
        title: 'Kulüp saatleri',
        popups: {
          title: 'Açılış saatleri'
        },
        changeAllWorkTimes: 'Tüm çalışma saatlerini değiştir'
      },
      contractTerms: {
        title: 'Kulüpteki çalışma koşulları',
        form: {
          minimalContractTerm: {
            label: 'Asgari sözleşme süresi',
            unit: 'Haftalar'
          },
          artistsSchedule: {
            label: 'Sanatçıların programı'
          }
        }
      },
      payments: {
        title: 'Ödemeler',
        rateFieldDescription:
          'Bir numaralı bir bahisiniz varsa, giriş alanlarından yalnızca birini doldurun'
      },
      workConditions: {
        title: 'Kulüpteki çalışma koşulları',
        form: {
          noExperienceEmployment: 'Deneyimsiz sanatçıların istihdamı',
          additionalInfo: {
            label: 'Kulüp hakkında ek bilgi',
            placeholder:
              'Kulübünüzdeki promosyonlar veya bonuslar veya sanatçılar için ilginç olacak diğer bilgiler hakkında yazabilirsiniz.',
            description: 'En az 100 karakter girin'
          }
        },
        popups: {
          dressCode: {
            enterDressCodeElement: 'Kod kodunun öğesini girin',
            description:
              'Kulübünüzdeki sanatçılar için kıyafet kodunu seçin. Eksik pozisyonlar ekleyin.'
          }
        }
      },
      housing: {
        title: 'Konut hakkında bilgi'
      },
      penalties: {
        title: 'Para cezası',
        description: 'Verilen listede bulamadıysanız pozisyonunuzu ekleyin'
      },
      photo: {
        title: 'Kulübün fotoğrafı',
        description:
          'Kulübün fotoğraflarını indirin. Daha sonra değişiklik yapabilirsiniz',
        options: {
          hallNoGuests: 'Boş bir salon fotoğrafı',
          hallWithGuests: 'Konuklar ile salonun fotoğrafı',
          privateRooms: 'Özel Odaların Fotoğrafı',
          scene: 'Sahnenin fotoğrafı'
        }
      },
      video: {
        title: 'Kulüp videosu',
        description:
          'Kulüp videosunu indirin. Daha sonra değişiklik yapabilirsiniz',
        options: {
          ClubTour: 'Boş salonun videosu',
          EventVideo: 'Konuklarla video salonu',
          WorkingHours: 'Video sahneleri'
        }
      }
    },
    artist: {
      work: {
        title: 'Kulüplerde deneyim',
        addWorkPlace: 'Bir iş yeri ekleyin',
        notHaveWorkExperience: 'Deneyimsiz devam edin'
      },
      language: {
        title: 'Diller',
        languageProfinience: 'Bowling yabancı diller'
      },
      parametres: {
        title: 'Parametreler'
      },
      about: {
        title: 'Kendin Hakkında',
        description:
          'Kulüp için neyin ilginç olacağını kendiniz hakkında yazın',
        textAreaDescription: 'En az 100 karakter girin',
        textAreaPlaceholder: 'Girmek'
      },
      video: {
        title: 'Video',
        videoForHostesVacancy: '2. Video sürücüsünü indirin',
        videoForGogoVacancy:
          '1. Videoyu bir boşluk şeridi dansçısı için nasıl dans ettiğinizi indirin ve git'
      },
      photo: {
        title: 'Fotoğraf',
        description:
          'Fotoğrafları indirin. Fotoğraflar filtreler ve Photoshop olmadan olmalıdır.',
        FaceNoMakeup: 'Model makyajsız bir yüzdür.',
        FaceWithMakeup: 'Yüz / yap -up.',
        FreePose: 'Ücretsiz bir pozda fotoğraf modeli.',
        FullBodyOnHeels: 'Topuklu tam yükseklikte modelin fotoğrafları.',
        LingerieOrSwimsuit: 'Bir mayodaki fotoğraf modeli',
        selectMainPhoto: 'Ana fotoğrafı seçin'
      }
    }
  },
  workInteraction: {
    club: {
      artistHaveContract: 'Sanatçı zaten kulüpte çalışıyor',
      incompleted: 'Davetiyeler göndermek için profilinizi%100 doldurmalısınız.'
    },
    artist: {
      weCanRequestLastWorkDate:
        'Kulüpten sözleşme bitiş tarihinizi talep edin.',
      clubSetLastWorkDate: 'Kulüp bu kulüpte son çalışma tarihinizi belirledi.',
      clubNotHiring:
        'Kulüp bir dizi sanatçı açmadığı için bir talep gönderemezsiniz.',
      pendingRequest: '48 saat içinde birden fazla istek gönderemezsiniz.',
      haveContract:
        'Mevcut bir sözleşmeniz olduğu için bir istek gönderemezsiniz.',
      hidden: 'Profiliniz aramadan gizlendiği için bir istek gönderemezsiniz.',
      incompleted:
        'Profili tamamen doldurmadığınız için bir istek gönderemezsiniz.'
    }
  },
  notFoundWorkItem: {
    title: 'Bu davet veya istek artık mevcut değil.',
    description: "Üzgünüz, ama sayfalar mevcut değil. Lütfen Vagial'e gidin."
  },
  notFoundCurrentWork: {
    title: 'Aktif sözleşme',
    description:
      'Şu anda aktif bir sözleşmeniz yok, arama sayfasına gidin ve bir sözleşme başlatmak için kulübe bir başvuru gönderin.'
  },
  clubFullProfile: {
    clubVideo: 'Kulüp videosu',
    clubPhoto: 'Kulübün fotoğrafı',
    clubHousingPhoto: 'Konut fotoğrafı',
    minimalContractDuration: 'Asgari sözleşme',
    artistWorkSchedule: 'Çalışma programı',
    paymentFrequescyMessage: 'Tüketme için sanatçıya ödemeler - 1 kez'
  },
  privacyPolicy: {
    title: 'Kullanıcı Sözleşmesi ve Gizlilik Politikası'
  },
  chat: {
    requestSupport: {
      inviteManagerInChat: 'Bir yöneticiyi sohbet etmeye davet edin',
      managerIsInChat: 'Sohbet yöneticisi',
      manageRequestPending: 'Yönetici yakında eklenecek'
    },
    admin: {
      assistanceProvided: 'Yardım sağlanır',
      openDirectChat: 'Открыть личный чат',
      openWhatsApp: 'WhatsApp\'ı aç',
      phoneNumberNotAvailable: 'Telefon numarası mevcut değil'
    }
  }
};
